import Component from './ProfileHeroV2';
import Container from './ProfileHeroV2.container';

export default Container(Component);
